export default "__VITE_ASSET__BG_F$jdu__"